/**
 * @generated SignedSource<<ccb29a6eedce71bffdfcc426b1e08913>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Payment_charge$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCharge_charge" | "PaymentProvider_charge">;
  readonly " $fragmentType": "Payment_charge";
};
export type Payment_charge$key = {
  readonly " $data"?: Payment_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Payment_charge",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCharge_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentProvider_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "9600dcc750cb4dfdac7f95b2b5705aca";

export default node;
